import { useRef } from "react";
import emailjs from "emailjs-com";

const ContactSection = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          alert("Message sent! I'll get back to you soon.");
          form.current.reset();
        },
        (error) => alert("Failed to send: " + error.text)
      );
  };

  return (
    <section id="contact" className="bg-[#0d0e18] py-24 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">

        <p className="text-[#f5c210] text-xs tracking-[0.2em] uppercase font-IBM mb-4">— Contact</p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

          {/* Left: info */}
          <div>
            <h2 className="font-IBM font-bold text-white text-4xl md:text-5xl leading-tight mb-6">
              Any Type of Query<br />&amp; Discussion.
            </h2>
            <p className="text-gray-400 font-IBM text-sm leading-relaxed max-w-sm mb-10">
              Have a project in mind or just want to say hello? Drop me a message and I'll get back to you within 24 hours.
            </p>

            <div className="space-y-5">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-[#1a1c2c] border border-[#1e2030] flex items-center justify-center text-[#f5c210] flex-shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <a
                  href="mailto:stefanlatic2002@gmail.com"
                  className="font-IBM text-sm text-[#f5c210] hover:underline"
                >
                  stefanlatic2002@gmail.com
                </a>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-[#1a1c2c] border border-[#1e2030] flex items-center justify-center text-[#f5c210] flex-shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <span className="font-IBM text-sm text-gray-400">Serbia, Niš</span>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-[#1a1c2c] border border-[#1e2030] flex items-center justify-center text-[#f5c210] flex-shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
                    <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                    <circle cx="4" cy="4" r="2"/>
                  </svg>
                </div>
                <a
                  href="https://linkedin.com/in/stefanlatic"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-IBM text-sm text-[#f5c210] hover:underline"
                >
                  linkedin.com/in/stefanlatic
                </a>
              </div>
            </div>
          </div>

          {/* Right: form */}
          <form ref={form} onSubmit={sendEmail} className="space-y-4">
            <div>
              <label className="font-IBM text-xs text-gray-500 tracking-widest uppercase block mb-2">
                What's your name?
              </label>
              <input
                type="text"
                name="name"
                placeholder="John Doe"
                required
                className="w-full bg-[#131523] border border-[#1e2030] rounded-lg px-4 py-3 font-IBM text-sm text-white placeholder-gray-600 focus:outline-none focus:border-[#f5c210]/60 transition-colors"
              />
            </div>

            <div>
              <label className="font-IBM text-xs text-gray-500 tracking-widest uppercase block mb-2">
                Your email
              </label>
              <input
                type="email"
                name="email"
                placeholder="john@example.com"
                required
                className="w-full bg-[#131523] border border-[#1e2030] rounded-lg px-4 py-3 font-IBM text-sm text-white placeholder-gray-600 focus:outline-none focus:border-[#f5c210]/60 transition-colors"
              />
            </div>

            <div>
              <label className="font-IBM text-xs text-gray-500 tracking-widest uppercase block mb-2">
                Your message
              </label>
              <textarea
                name="message"
                rows="5"
                placeholder="Tell me about your project..."
                required
                className="w-full bg-[#131523] border border-[#1e2030] rounded-lg px-4 py-3 font-IBM text-sm text-white placeholder-gray-600 focus:outline-none focus:border-[#f5c210]/60 transition-colors resize-none"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-[#f5c210] text-[#0d0e18] font-IBM font-semibold text-sm py-3 rounded-lg hover:bg-yellow-300 transition-colors"
            >
              Send Message →
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
